<template>
	<div class="content">
		<div class="section">
			<div class="tag flex-row">
				<div class="flex-column ">
				<img src="../../assets/img/btzs-icon.png">
				<span>开票基础信息</span></div>
		
			</div>
			<div class="baseInfo">
				<div class="Inputbox">
					<div class="info">
						<div class="item flex-row">
							<span>抬头类型：</span>
							{{content.invoiceClassify==0?'公司':'个人'}}
						</div>
						<div class="item flex-row">
							<span>抬头名称：</span>
							{{content.invoiceHeader}}
						</div>
						<div class="item flex-row" v-if="content.invoiceClassify==0">
							<span>公司税号：</span>
							{{content.companyTaxNumber}}
						</div>
						<div class="item flex-row">
							<span>电子邮箱：</span>
							{{content.email}}
						</div>
					</div>
				</div>
			</div>
			<div class="tag flex-row">
					<div class="flex-column ">
				<img src="../../assets/img/btzs-icon.png">
				<span>更多信息</span></div>
		
			</div>
			<div class="more">
				<div class="info">
					<div class="item flex-row">
						<span>公司地址：</span>
						{{content.companyAddress?content.companyAddress:'暂无'}}
					</div>
					<div class="item flex-row">
						<span>公司电话：</span>
						{{content.companyMobile?content.companyMobile:'暂无'}}
					</div>
					<div class="item flex-row">
						<span>开&ensp;户&ensp;行：</span>
						{{content.bankName?content.bankName:'暂无'}}
					</div>
					<div class="item flex-row">
						<span>开户账号：</span>
						{{content.bankAccount?content.bankAccount:'暂无'}}
					</div>
					<div class="item flex-row textarea">
						<span>备&emsp;&emsp;注：</span>
						{{content.invoiceContent?content.invoiceContent:'暂无'}}
					</div>
				</div>
			</div>
			<div class="tag flex-row">
							<div class="flex-column ">
				<img src="../../assets/img/btzs-icon.png">
				<span>发票信息</span></div>
		
			
			</div>
			<div class="invoiceinfo">
				<span class="title">发票内容</span>
				<div class="table">
					<div class="item flex-row">
						<div class="name">
							开票类型
						</div>
						<span>*文化服务*门票</span>
					</div>
					<div class="item flex-row">
						<div class="name">
							开票方
						</div>
						<span>四川大学博物馆</span>
					</div>
					<div class="item flex-row">
						<div class="name">
							开票金额
						</div>
						<span>￥{{content.totalPrice}}</span>
					</div>
				</div>
			</div>
			<div class="btnbox flex-row">
				<div class="backbtn cursorp" @click="toPage">
					返回
				</div>
				<div class="confirmbtn cursorp" @click="resetOpenInvoice" v-if="content.changeStateFlag==0">
					重新开票
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		merchantNo,
		getInvoiceDetail
	} from '@/utils/http.js'
	export default {
		name: 'invoiceDetail',
		data() {
			return {
				id: '',
				content: {}
			}
		},
		mounted() {
			// 获取上一页传递过来的参数
			let params = this.$route.query
			this.id = params.id != undefined ? params.id : '' //id不为空表示点击的是重开
			this.getInvoiceDetail({
				id: this.id
			})
		},
		methods: {
			// 获取开票详情信息
			getInvoiceDetail(params) {
				getInvoiceDetail(params).then((res) => {
					let data = res.data
					this.content = data
				})
			},
			// 申请重开
			resetOpenInvoice() {
				let orderNoArr = [this.content.orderSn]
				this.$router.push({
					name: "InvoiceInfo",
					params: {
						totalPrice: this.content.totalPrice, //订单总价
						id: this.id, //点击重开数据id
						orderNo: orderNoArr, //订单号
					}
				})
			},
			// 返回上一页
			toPage() {
				this.$router.back()
			},
		},
	}
</script>

<style scoped>
	.content {
		width: 1200px;
		background:#fff;
		background-size: 100% 100%;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
		margin: auto;
		padding: 24px;
		box-sizing: border-box;
	}

	.baseInfo {
		padding: 0 60px;
		box-sizing: border-box;
	}

	.baseInfo .nav-item {
		padding: 0 36px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 6px;
		border: 1px solid #999999;
		box-sizing: border-box;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #999999;
		margin-right: 18px;
		line-height: 40px;
		margin-bottom: 24px;
	}

	/* nav激活样式 */
	.activeNav {
		background: #BB2916 !important;
		border: none !important;
		color: #ffffff !important;
	}

	.Inputbox {
		justify-content: space-between;
	}

	.info .item {
		margin-bottom: 16px;
		font-size: 16px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #333;
	}

	.info .item span {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #333;
		margin-right: 14px;
	}

	.more {
		width: 1008px;
		margin-left: 60px;
	}

	.more .info {
		width: 100%;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.invoiceinfo {
		width: 1008px;
		margin-left: 60px;
		margin-bottom: 24px;
		display: flex;
		flex-direction: row;
	}

	.invoiceinfo .title {
		font-size: 16px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		margin-right: 15px;
		margin-top: 10px;
		display: block;
	}

	.invoiceinfo .table {
		width: 921px;
		background: #FFFFFF;
		border: 1px solid #C2C2C2;
	}

	.table .item {
		height: 40px;
		width: 100%;
		border-bottom: 1px solid #C2C2C2;
	}

	.table .item:last-child {
		border-bottom: none;
	}

	.table .item .name {
		width: 192px;
		height: 100%;
		background: #FAFAFA;
		line-height: 40px;
		text-align: center;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.table .item span {
		display: block;
		width: 728px;
		height: 100%;
		padding: 0 16px;
		box-sizing: border-box;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
		color: #BB2916;
		line-height: 40px;
	}

	.btnbox {
		justify-content: center;
		margin-top: 24px;
	}

	.backbtn {
		width: 324px;
		height: 60px;
		background: #ffffff;
		border-radius: 30px;
		line-height: 60px;
		text-align: center;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #BB2916;
		border: 1px solid #BB2916;
		margin-right: 32px;
	}

	.confirmbtn {
		width: 324px;
		height: 60px;
		background: #BB2916;
		border-radius: 30px;
		line-height: 60px;
		text-align: center;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}

	/deep/ .baseInfo .item .el-input {
		width: 920px;
		height: 40px;
	}

	/deep/ .baseInfo .item .el-input__inner {
		width: 920px;
		height: 40px;
		background: #FAFAFA;
		border: 1px solid #E9E9E9;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}

	/deep/ .more .item .el-input {
		width: 412px;
		height: 40px;
	}

	/deep/ .more .item .el-input__inner {
		width: 412px;
		height: 40px;
		background: #FAFAFA;
		border: 1px solid #E9E9E9;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}

	/deep/ .more .textarea .el-textarea {
		width: 920px;
		height: 188px;
	}

	/deep/ .more .textarea .el-textarea__inner {
		width: 920px;
		height: 188px;
		background: #FAFAFA;
		border: 1px solid #E9E9E9;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
	}
</style>
